module.exports = __webpack_public_path__ + "media/chourlih.98f67f63.mp3";